export default __webpack_public_path__ + "static/media/HistoricOrigin.46aea415.svg";